import Vue from "vue";
import App from "./App.vue";
import router from "./router/index";
import "./assets/iconfont/iconfont.css";
// 公共样式
import "./assets/css/style.scss";
// swiper
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/css/swiper.css";
// 饿了么
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);
// 防止快速点击重复调用接口
import preventReClick from "@/assets/js/preventReClick";
//视频插件
import Videojs from 'video.js'
import 'video.js/dist/video-js.css'


Vue.use(preventReClick);
Vue.prototype.$previewPath = process.env.VUE_APP_API_BASE_URL + "/preview/";
Vue.prototype.$video = Videojs
import SSO from "@/cas/sso.js";
SSO.init(() => {
  main();
});
//md5加密
import md5 from "js-md5";
//Highcharts图表
import Highcharts from "highcharts";
import HighchartsVue from "highcharts-vue";
import highcharts3d from "highcharts/highcharts-3d";
highcharts3d(Highcharts);
Vue.use(HighchartsVue);
import { formatDate } from "./common/date";
//导入按钮防抖
import { noMultipleClicks } from "./common/no-multiple-clicks";
import { isEmptyObj } from "./common/common.js";
import * as echarts from "echarts";
// vuex
import Vuex from "vuex";
import store from "./store";
/* 滑动验证码 */
import SlideVerify from "vue-monoplasty-slide-verify";
Vue.use(Vuex);
Vue.use(VueAwesomeSwiper);
Vue.use(SlideVerify);
Vue.prototype.$TimeData = formatDate;
Vue.prototype.$noMultipleClicks = noMultipleClicks;
Vue.prototype.$isEmptyObj = isEmptyObj;
Vue.config.productionTip = false;
window._CONFIG = {};
window._CONFIG._URL = {};
Vue.prototype.$md5 = md5;
function main() {
  new Vue({
    strict: false,
    router,
    store,
    render: (h) => h(App),
  }).$mount("#app");
}
